import clsx from "clsx";

export interface ExternalLinkProps {
    className?: string;
    style?: React.CSSProperties;
    href: string;
    children: React.ReactNode;
}

function ExternalLink({ className, children, ...rest }: ExternalLinkProps) {
    return (
        <a className={clsx("external-link", className)} target="_blank" rel="noreferrer" {...rest}>
            {children}
        </a>
    );
}

export default ExternalLink;
